const AUTH_KEY = 'authUser';

export const getAuthUserString = (): string | null => {
  try {
    return localStorage.getItem(AUTH_KEY) || sessionStorage.getItem(AUTH_KEY);
  } catch {
    return null;
  }
};

export const isAuthPersisted = (): boolean => {
  try {
    return !!localStorage.getItem(AUTH_KEY);
  } catch {
    return false;
  }
};

export const setAuthUserString = (value: string, persist: boolean): void => {
  try {
    if (persist) {
      localStorage.setItem(AUTH_KEY, value);
      sessionStorage.removeItem(AUTH_KEY);
    } else {
      sessionStorage.setItem(AUTH_KEY, value);
      localStorage.removeItem(AUTH_KEY);
    }
  } catch {
    // ignore storage errors
  }
};

export const clearAuthUser = (): void => {
  try {
    localStorage.removeItem(AUTH_KEY);
    sessionStorage.removeItem(AUTH_KEY);
  } catch {
    // ignore storage errors
  }
};

export const getAuthUser = (): any | null => {
  const raw = getAuthUserString();
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
